/* @flow */

import React, { Component } from 'react';
import { Modal, Header, Message, Button } from 'semantic-ui-react';

type Props = {
  children?: (onClick: () => void) => Element,
  onDeployed: () => void,
};

type State = {
  modalOpened: boolean,
};

class DeployButton extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      modalOpened: false,
    };
  }

  onCancel = () => this.setState({ modalOpened: false });
  onShow = () => this.setState({ modalOpened: true });

  onConfirm = () => {
    const { onDeployed } = this.props;

    this.setState({ modalOpened: false }, onDeployed);
  };

  render() {
    const { children } = this.props;
    const { modalOpened } = this.state;

    return (
      <div>
        <Modal open={modalOpened} onClose={this.onCancel} closeIcon>
          <Header content="Déploiement en production" />
          <Modal.Content>
            <Message
              icon="info circle"
              header={`
                Vous-êtes sur le point de mettre la version courante de l'application en production.
                Êtes-vous sûr(e) ?
              `}
            />
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={this.onCancel}
              labelPosition="left"
              icon="close"
              content="Annuler"
            />
            <Button
              onClick={this.onConfirm}
              color="red"
              labelPosition="right"
              icon="upload"
              content="Deployer"
            />
          </Modal.Actions>
        </Modal>
        {children && children(this.onShow)}
      </div>
    );
  }
}

export default DeployButton;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/Deployments/components/DeployButton.js